


import LoaderComponent from '@/shared/components/Loader.vue'
import PdfComponent from './PdfComponent.vue'
import AtomButton from "../atoms/AtomButton.vue"
import AtomImage from "../atoms/AtomImage.vue"
import AtomLogo from "../atoms/AtomLogo.vue"
import MoleculeAccordion from "../molecules/MoleculeAccordion.vue";
import MoleculeAccordionItem from "../molecules/MoleculeAccordionItem.vue";
import MoleculeCard from "../molecules/MoleculeCard.vue";
import MoleculeContentBlock from "../molecules/MoleculeContentBlock.vue";
import MoleculeNotification from "../molecules/MoleculeNotification.vue";
import LayoutDefaultBlock from "../layout/LayoutDefaultBlock.vue";
import Layout from "../layout/Layout.vue";
import {computed, defineComponent, onMounted} from "@vue/composition-api";
import {useStore} from "vuex-composition-helpers";

export default defineComponent({
  name: "ResultComponent",
  components: {
    AtomButton,
    AtomImage,
    AtomLogo,
    MoleculeAccordion,
    MoleculeAccordionItem,
    MoleculeCard,
    MoleculeContentBlock,
    MoleculeNotification,
    LayoutDefaultBlock,
    Layout,
    LoaderComponent,
    PdfComponent
  },
  setup: () => {
    const store = useStore();

    function restartApp() {
      store.dispatch('restart')
      store.commit('toggleExplanation')
      store.commit('goToQuestions')
    }

    onMounted(() => {
      if (computed(() => store.getters.showResults)) {
        store.dispatch('loadResults')
      }
    })

    return {
      restartApp,
      resultViewModel: computed(() => store.getters.resultViewModel),
      showResults: computed(() => store.getters.showResults),
      loading: computed(() => store.state.loading),
      labels: computed(() => store.getters.labels),
      highestRating: computed(() => store.getters.highestRating),
      results: computed(() => store.state.results),
      sortedRatings: computed(() => store.getters.sortedRatings),
    }
  }
})
